<template>
  <div>
    <b-container fluid>
      <b-overlay
        :show="showTrophy"
        rounded="sm"
      >
        <b-row>
          <b-col lg="3"></b-col>
          <b-col lg="5" class="text-center">
            <!-- Promotion Modal -->
            <b-modal id="premmodal" centered title="Upgrade to Premium!">
              <template #default>
                <div>
                  <p>By Upgrading to Premium, You Enjoy</p>

                  <b-table-simple hover small striped>
                    <tr>
                      <th>Features</th>
                      <th>Basic</th>
                      <th>Premium</th>
                    </tr>

                    <tr>
                      <td>Unlimited Practice</td>
                      <td>
                        3 days Free Trials + 2 Mins of Free Practice anytime
                      </td>
                      <td>
                        <b-icon-check2
                          font-scale="2"
                          variant="success"
                        ></b-icon-check2>
                      </td>
                    </tr>

                    <tr>
                      <td>Access to</td>
                      <td>Limited Questions</td>
                      <td>All Questions</td>
                    </tr>

                    <tr>
                      <td>AI Study Room</td>
                      <td>
                        <b-icon-dash
                          font-scale="2"
                          variant="danger"
                        ></b-icon-dash>
                      </td>
                      <td>
                        <b-icon-check2
                          font-scale="2"
                          variant="success"
                        ></b-icon-check2>
                      </td>
                    </tr>

                    <tr>
                      <td>Practice Modes</td>
                      <td>
                        <b-icon-dash
                          font-scale="2"
                          variant="danger"
                        ></b-icon-dash>
                      </td>
                      <td>
                        <b-icon-check2
                          font-scale="2"
                          variant="success"
                        ></b-icon-check2>
                      </td>
                    </tr>

                    <tr>
                      <td>Topic References</td>
                      <td>
                        <b-icon-dash
                          font-scale="2"
                          variant="danger"
                        ></b-icon-dash>
                      </td>
                      <td>
                        <b-icon-check2
                          font-scale="2"
                          variant="success"
                        ></b-icon-check2>
                      </td>
                    </tr>

                    <tr>
                      <td>Questions Review and Indepth Solutions</td>
                      <td>
                        <b-icon-dash
                          font-scale="2"
                          variant="danger"
                        ></b-icon-dash>
                      </td>
                      <td>
                        <b-icon-check2
                          font-scale="2"
                          variant="success"
                        ></b-icon-check2>
                      </td>
                    </tr>

                    <tr>
                      <td>Download Solutions</td>
                      <td>
                        <b-icon-dash
                          font-scale="2"
                          variant="danger"
                        ></b-icon-dash>
                      </td>
                      <td>
                        <b-icon-check2
                          font-scale="2"
                          variant="success"
                        ></b-icon-check2>
                      </td>
                    </tr>

                    <tr>
                      <td>Scheduler</td>
                      <td>
                        <b-icon-dash
                          font-scale="2"
                          variant="danger"
                        ></b-icon-dash>
                      </td>
                      <td>
                        <b-icon-check2
                          font-scale="2"
                          variant="success"
                        ></b-icon-check2>
                      </td>
                    </tr>

                    <tr>
                      <td>Leaderboard</td>
                      <td>
                        <b-icon-dash
                          font-scale="2"
                          variant="danger"
                        ></b-icon-dash>
                      </td>
                      <td>
                        <b-icon-check2
                          font-scale="2"
                          variant="success"
                        ></b-icon-check2>
                      </td>
                    </tr>

                    <tr>
                      <td>Performance Metrics</td>
                      <td>
                        <b-icon-dash
                          font-scale="2"
                          variant="danger"
                        ></b-icon-dash>
                      </td>
                      <td>
                        <b-icon-check2
                          font-scale="2"
                          variant="success"
                        ></b-icon-check2>
                      </td>
                    </tr>
                  </b-table-simple>
                </div>
              </template>

              <template #modal-footer>
                <b-link :to="{ name: 'upgrade' }" class="w-100 text-center">
                  <b-button class="bgupgrade mx-auto"
                    >Upgrade to Premium Now</b-button
                  >
                </b-link>
              </template>
            </b-modal>

            <div class="comwrap text-center mt-5 p-1">
              <!-- Check if user is a free user and if user has more than zero trials left -->
              <div v-if="checkTrial2() && entryType == 'platform'">
                <b-alert
                  v-if="!discountdetails?.discount_season"
                  show
                  variant="info"
                  dismissible
                >
                  <h4>
                    You have {{ trial }} {{ trial > 1 ? "days" : "day" }} trial
                    Left
                  </h4>
                  <p>
                    <b-link :to="{ name: 'upgrade' }"
                      >Upgrade to Premium Now</b-link
                    >
                  </p>
                </b-alert>

                <b-alert
                  v-else
                  dismissible
                  :show="discountdetails?.discount_season"
                  variant="info"
                >
                  <p class="discount-text">
                    Discount alert! {{ discountdetails?.discount_title }}!
                  </p>
                  <p class="discount-text">
                    <strong class="discount-value"
                      >{{ discountdetails?.discount_percentage }}%</strong
                    >
                    off on all upgrades
                  </p>
                  <b-button
                    class=" p-lg-2"
                    :to="{ name: 'upgrade' }"
                    variant="info"
                    >Upgrade NOW</b-button
                  >
                </b-alert>
              </div>

              <div class="mt-2"></div>

              <div class="congrats mt-3">
                <b-avatar
                  size="10rem"
                  class="mt-5"
                  :src="userdet.profileimage"
                ></b-avatar>
                <h5 v-if="totscore.view_score == 'Yes'" class="mt-5 text-bold">
                  <b>You Scored</b>
                </h5>
                <p v-if="totscore.view_score == 'Yes'" class="mt-5 score-line">
                  {{ totscore.tscore }}/{{ totscore.tmark }}
                </p>

                <div class="mt-5">
                  <b-row>
                    <b-col md="5" class="mt-2 pl-lg-3">
                      <b-overlay
                        :show="exiting"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class=""
                      >
                        <b-button
                          variant="outline-success"
                          v-if="totscore.test_source == 'base'"
                          class="p-3 ml-lg-5 subbtn"
                          @click="tryAgain()"
                          >Take test again</b-button
                        >
                      </b-overlay>
                    </b-col>
                    <b-col md="7" class="mt-2 pr-lg-3">
                      <b-overlay
                        :show="reviewing"
                        rounded
                        opacity="0.6"
                        spinner-small
                        spinner-variant="primary"
                        class=""
                      >
                        <b-link
                          :to="{
                            name: 'breakdown',
                            params: { trackid: this.totscore.trackid }
                          }"
                        >
                          <b-button
                            v-if="totscore.view_solution == 'Yes'"
                            variant="success"
                            @click="exitreview"
                            class="p-3 mr-lg-5 check-button"
                            >Check answers and solutions
                          </b-button>
                        </b-link>
                      </b-overlay>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col :lg="entryType == 'platform' ? 6 : 12">
                      <b-button
                        variant="danger"
                        v-if="totscore.test_source == 'thirdparty'"
                        class="p-3 ml-10 w-full"
                        @click="loggingOut()"
                        >Exit Exam Hall</b-button
                      >
                    </b-col>
                    <b-col lg="6" class="col-lg-6">
                      <b-button
                        variant="success"
                        v-if="totscore.test_source == 'thirdparty' && entryType == 'platform'"
                        class="p-3 ml-10 w-full"
                        @click="toDashboard()"
                        >Go to Dashboard</b-button
                      >
                    </b-col>
                  </b-row>
                </div>
              </div>
              <div>
                <p class="teller-friends mt-5 mb-5">
                  Tell friends about quicktest
                  <a
                    :href="
                      'whatsapp://send?text=I just did a test on Quicktest. Its helping me improve, it can help you too. Join me practice to high performance on ' +
                        origin
                    "
                    data-action="share/whatsapp/share"
                    target="blank"
                  >
                    <img class="iconshare" src="@/assets/whatrpng.png"
                  /></a>
                  <a
                    :href="
                      'https://twitter.com/intent/tweet?via=quicktestng&text=I just did a test on Quicktest. Its helping me improve, it can help you too. Join me practice to high performance on ' +
                        origin
                    "
                    target="blank"
                    ><img src="@/assets/twitblue.jpg" class="iconshare"
                  /></a>
                  <a
                    target="blank"
                    :href="
                      'https://www.facebook.com/sharer/sharer.php?u=' +
                        origin +
                        '&quote=I just did a test on Quicktest. Its helping me improve, it can help you too. Join me practice to high performance on Quicktest(' +
                        origin +
                        ')'
                    "
                    ><img src="@/assets/fnorig.jpg" class="iconshare"
                  /></a>
                </p>
              </div>
            </div>
          </b-col>
          <b-col lg="4"></b-col>
        </b-row>

        <template #overlay>
          <div class="icon-x-wrapper w-100 d-flex justify-content-end">
            <b-icon-x-lg
              style="cursor:pointer"
              class=""
              font-scale="1.5"
              @click="(showTrophy = false), showPreModal()"
            />
          </div>

          <div class="w-100">
            
            <div class="text-center">
              <div class="points-div">
                <p style="font-size: 30px; font-weight: bold;">Congrats!</p>
                <p
                  style="font-size: 60px; font-weight: bold;"
                  class="point-value"
                >
                  {{ totscore.qt_points }}
                </p>
                <p style="font-size: 20px">QT Points Added to you!</p>
              </div>
  
              <img src="@/assets/goldenTrophy2.png" class="trophy-image" />
  
              <p class="point-info">
                Practice more often and get better scores to get more QT Points
                and Climb up the Leaderboard (Coming Soon)
              </p>
            </div>

            
          </div>
        </template>
      </b-overlay>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import store from "@/store";

export default {
  data() {
    return {
      exiting: false,
      trying: false,
      curD: new Date(),
      reviewing: false,
      showTrophy: true
    };
  },
  created() {
    if (!this.loggedin) {
      this.$router.push({
        name: "icon"
      });
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.name != "landing" && to.name != "select") {
      store.dispatch("dashboard/getmaxiresults");
      store.dispatch("dashboard/getminiresults");
      this.reviewing = false;
      next();
    } else {
      next();
    }
  },

  mounted() {
    //console.log(this.plan);
    this.updateDetails()
    if (this.$route.query.redirect == "upgrade") {
      this.$router.push({
        name: "upgrade"
      });
    }

    if(this.totscore.qt_points <= 0){
      this.showTrophy = false
      this.showPreModal();
    }else{
      this.showPreModal();
    }
    
  },

  beforeRouteEnter(to, from, next) {
    let path = from.name;

    if (to.query.redirect == "upgrade") {
      next(vm => {
        vm.$router.push({
          name: "upgrade"
        });
      });
    }

    if (path == "testhall") {
      next();
    } else if (path == "select") {
      next(vm => {
        vm.$router.push({
          name: "dashboard"
        });
      });
    } else {
      next(vm => {
        if (vm.submitted == true) {
          vm.$router.push({
            name: "select"
          });
        } else {
          return true;
        }
      });
    }
  },
  methods: {
    ...mapActions(["logOut"]),
    ...mapActions("loginmaster", [
      "updateDetails"
    ]),
    exitHall() {
      this.exiting = true;
      this.$router.push({
        name: "landing"
      });
    },
    showPreModal() {
      if (
        this.plan != "Premium" &&
        this.totscore.test_source == "base" &&
        !this.freePeriod &&
        !this.showTrophy
      ) {
        setTimeout(() => {
          this.$bvModal.show("premmodal");
        }, 1000);
      }
    },
    toDashboard(){
      this.$router.push({
        name: "dashhome"
      });
    },
    loggingOut() {
      let now = new Date();
      now.setFullYear(now.getFullYear() - 20);
      document.cookie = `remember=;expires=${now.toUTCString()}`;
      document.cookie = `qid=;expires=${now.toUTCString()}`;
      this.logOut().then(() => {
        if(this.entryType == 'platform'){
          this.$router.push({
            name: "login"
          });
        }else if(this.entryType == 'portal'){
          this.$router.push({
            name: "orgportallogin",
            params: {
              orgShortname : this.org_details.organization_shortname.toLowerCase()
            }
          });
        }else{
          this.$router.push({
            name: "login"
          });
        }
        
      });
    },
    exitreview() {
      this.reviewing = true;
    },
    tryAgain() {
      this.trying = true;
      this.$router.push({
        name: "select"
      });
    },
    checkTrial2() {
      if (this.trial >= 0 && this.plan != "Premium" && !this.freePeriod) {
        return true;
      }
    }
  },
  computed: {
    ...mapState({
      started: state => state.exam.started,
      loggedin: state => state.loginmaster.loggedIn,
      subjects: state => state.exam.start_config.subjects,
      entryType: state => state.loginmaster.entryType,
      submitted: state => state.exam.submitted,
      userdet: state => state.loginmaster.details,
      org_details: state => state.loginmaster.org_details,
      plan: state => state.loginmaster.details.plan,
      trial: state => state.loginmaster.trial,
      totscore: state => state.exam.totalscore,
      origin: state => state.loginmaster.site_origin,
      freePeriod: state => state.loginmaster.freePeriod,
      discountdetails: state => state.loginmaster.details.discount_details
    }),

    variant() {
      if (this.totscore.tscore < (50 / 100) * this.totscore.tmark) {
        return "danger";
      } else if (
        this.totscore.tscore > (50 / 100) * this.totscore.tmark &&
        this.totscore.tscore < (70 / 100) * this.totscore.tmark
      ) {
        return "success";
      } else if (this.totscore.tscore > (70 / 100) * this.totscore.tmark) {
        return "info";
      } else {
        return "secondary";
      }
    }
  }
};
</script>

<style scoped>
.comwrap {
  background-color: white;
  border-radius: 10px;
  width: 700px;
}

.comimg {
  width: 40%;
  height: 40vh;
}

.subbig {
  font-size: 40px;
  color: #00377b;
  font-weight: bolder;
}

.subsmall {
  font-size: 20px;
}

.subbtn {
  font-size: 1.3rem;
  font-weight: bolder;
  border: 1px solid #00984a;
  cursor: pointer;
  color: black;
}
.subbtn:hover {
  background-color: #00377b;
  color: white;
  border: 0px;
}

.tsb {
  font-size: 1.2rem;
}

.iconshare {
  width: 40px;
  height: 30px;
  margin: 3px;
}

.bgupgrade {
  background-color: #00377b;
  color: white;
  font-size: 1.3rem;
  font-weight: bold;
}

.bgupgrade:hover {
  background-color: white;
  color: #00377b;
}
.score-line {
  font-size: 2.2rem;
  font-weight: bolder;
}
.check-button {
  background-color: #00984a;
  font-size: 1.3rem;
  border: 0px;
}
.check-button:hover {
  background-color: transparent;
  color: #00377b;
  border: 1px solid #00377b;
}
.teller-friends {
  font-size: 1.5rem;
}

.trophy-image {
  width: 70%;
  height: 70%;
}

.points-div {
  color: rgb(20, 20, 52);
}

.point-info{
  font-size: 20px;
}

.trophy-image {
  transform-origin: center;
  animation: rollCup 5s ease-in-out forwards;
}

.icon-x-wrapper{
  top:-4rem;
  right:-18rem;
  position:absolute
}

@keyframes rollCup {
  0% {
    transform: rotate(0deg) scale(1);
  }
  80% {
    transform: rotate(1800deg) scale(2); /* Rotates 5 times (360*5=1800) and scales up */
  }
  
  95% {
    transform: rotate(0deg) scale(4); /* Returns to normal position and size */
  }

  100% {
    transform: rotate(0deg) scale(1); /* Returns to normal position and size */
  }
}

@media (max-width: 999px) {
  .comimg {
    width: 50%;
  }

  .point-info{
    font-size: 14px;
  }

  .comwrap {
    width: 100%;
  }
  .teller-friends {
    font-size: 1rem;
  }
  .icon-x-wrapper{
    top:-13rem;
    right:-4rem;
    position:absolute
  }
}
</style>
